import React, { useState, useMemo } from "react";
import {
  Box,
  Container,
  Typography,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { useDispatch, useSelector } from "react-redux";
import { StoreDispatch, StoreState } from "../redux/reduxStore.ts";
import { ProductData } from "../services/product/types.ts";
import { removeItemFromCart } from "../redux/cart/actions.ts";
import CartProduct from "../commponents/CartProduct.tsx";
import { useNavigate } from "react-router-dom";
import emptyCart from "../assets/empty-cart.png";
const VAT_RATE = 0.079; // 7.9%

const Cart = () => {
  const theme = useTheme();
  const cartData = useSelector((state: StoreState) => state.cart);
  const dispatch = useDispatch<StoreDispatch>();
  const navigate = useNavigate();

  const onCheckOut = () => {
    navigate("/checkOut");
  };

  const removeItem = (product: ProductData) => {
    dispatch(removeItemFromCart({ productData: product }));
  };

  // Calculate totals
  const { total, vatAmount, grandTotal } = useMemo(() => {
    const total = cartData.cartProducts.reduce(
      (sum, item) => sum + item.productData.price * item.quantity,
      0
    );
    const vatAmount = total * VAT_RATE;
    const grandTotal = total + vatAmount;
    return { total, vatAmount, grandTotal };
  }, [cartData.cartProducts]);

  return (
    <>
      <Container sx={{ py: 2 }}>
        {cartData.cartProducts.length > 0 && (
          <Box sx={{ paddingBottom: 12 }}>
            <Table>
              <TableHead sx={{ backgroundColor: "#b7472a" }}>
                <TableRow>
                  <TableCell sx={style.tHead}>Product Name</TableCell>
                  <TableCell sx={style.tHead}>Price</TableCell>
                  <TableCell sx={style.tHead}>Quantity</TableCell>
                  <TableCell sx={style.tHead}>Total</TableCell>
                  <TableCell sx={style.tHead}>Remove</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cartData.cartProducts.map((item, index) => (
                  <CartProduct
                    key={index}
                    productData={item.productData}
                    quantity={item.quantity}
                    onPressTrash={() => removeItem(item.productData)}
                  />
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
        {cartData.cartProducts.length <= 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontSize: 30, textAlign: "center", fontWeight: 700 }}
            >
              Your cart is empty
            </Typography>
            <img
              src={emptyCart}
              alt={"empty"}
              style={{
                width: "100%",
                height: "50vh",
                marginRight: "10px",
                objectFit: "contain",
              }}
            />
            <Button
              variant="contained"
              sx={{
                mt: 2,
                backgroundColor: "#b7472a",
                "&:hover": { backgroundColor: "#8E2B1E" },
                display: "flex",
                // width: "100%",
              }}
              href="/"
            >
              Continue Shopping
            </Button>
          </Box>
        )}
      </Container>

      {/* Billing Section */}
      {cartData.cartProducts.length > 0 && (
        <Box
          sx={{
            textAlign: "center",
            p: 3,
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            boxShadow: 3,
            // maxWidth: 400,
            margin: "100px",
          }}
        >
          <Typography variant="h6" sx={style.heading}>
            Billing Summary
          </Typography>
          <Box display="flex" justifyContent="space-between" sx={style.billRow}>
            <Typography>Total:</Typography>
            <Typography>${total.toFixed(2)}</Typography>
          </Box>
          {/* <Box display="flex" justifyContent="space-between" sx={style.billRow}>
            <Typography>VAT (7.9%):</Typography>
            <Typography>${vatAmount.toFixed(2)}</Typography>
          </Box> */}
          <Box
            display="flex"
            justifyContent="space-between"
            sx={{ ...style.billRow, fontWeight: "bold" }}
          >
            <Typography>Grand Total:</Typography>
            <Typography>${grandTotal.toFixed(2)}</Typography>
          </Box>
          <Button
            variant="contained"
            sx={{
              mt: 2,
              backgroundColor: "#b7472a",
              "&:hover": { backgroundColor: "#8E2B1E" },
              width: "100%",
            }}
            endIcon={<ShoppingBagIcon />}
            onClick={onCheckOut}
          >
            Proceed to Checkout
          </Button>
        </Box>
      )}
    </>
  );
};

export default Cart;

const style = {
  heading: {
    fontWeight: 500,
    fontFamily: "Spectral, serif",
    fontSize: "20px",
    textAlign: "center",
    marginBottom: "10px",
  },
  billRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
  },
  tHead: {
    fontFamily: "Spectral, serif",
    color: "white",
    padding: "16px",
    fontSize: "18px",
    letterSpacing: 1,
  },
};
